import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getBarcodeImage } from "../../../redux/action/drop_list_action";
import { useQueries, useQuery } from "@tanstack/react-query";
import { fetchHeaderFooterImageList } from "services/headerFooterDetail";
import { STALE_TIME } from "utils/constants";
import {
  fetchDowloadDocument,
  fetchDownloadInvestigationDocument,
  fetchInvestigationDowloadDocument,
  fetchReportPDf,
} from "services/resultEntryReportMaster";
import { fetchSignature } from "services/doctor";
import zoneLocalStorageId from "utils/zone";
import RenderPdfFromBase64 from "./RenderPdfFromBase64";
import NABL_LOGO from "../../../assets/images/NABL_LOGO.png";
import jwtDecode from "jwt-decode";

const InvoicePage = ({ onClose, rowData, zoneRegistrationData }) => {
  const search = useLocation().search;
  const display_header = new URLSearchParams(search).get("display_header");
  const display_banner = new URLSearchParams(search).get("display_banner");
  const display_footer = new URLSearchParams(search).get("display_footer");
  const display_footer_banner = new URLSearchParams(search).get(
    "display_footer_banner",
  );
  const display_address = new URLSearchParams(search).get("display_address");
  const display_watermark = new URLSearchParams(search).get(
    "display_watermark",
  );
  const token = new URLSearchParams(search).get("token");
  const zoneId = new URLSearchParams(search).get("zone_id");

  const display_header_data = new URLSearchParams(search).get(
    "display_header_data",
  );
  const investigationIds = new URLSearchParams(search).getAll(
    "investigation_ids",
  );
  const appointment = new URLSearchParams(search).get("appointment_id");

  const dispatch = useDispatch();
  const { barcode_detail } = useSelector((state) => state.dropListReducer);

  const jwtAuthreducer = useSelector((state) => state.jwtAuthreducer);

  // const _token =
  //   jwtAuthreducer?.token_values?.sub &&
  //   JSON.parse(jwtAuthreducer?.token_values?.sub?.replace(/'/g, '"'));

  const _token =
    jwtAuthreducer?.token_values?.sub &&
    JSON.parse(
      jwtAuthreducer?.token_values?.sub
        .replace(/'/g, '"')
        .replace(/\bNone\b/g, "null")
        .replace(/\bTrue\b/g, "true")
        .replace(/\bFalse\b/g, "false"),
    );

  function convertSecondsToAge(seconds) {
    const secondsInYear = 31536000;
    const secondsInMonth = 2629746;
    const secondsInDay = 86400;

    const years = Math.floor(seconds / secondsInYear);
    seconds %= secondsInYear;

    const months = Math.floor(seconds / secondsInMonth);
    seconds %= secondsInMonth;

    const days = Math.floor(seconds / secondsInDay);

    return { years, months, days };
  }

  function convertTimestampToDatetimeLocal(timestamp, showTime) {
    if (!timestamp) return "";
    const date = new Date(timestamp * 1000);
    if (isNaN(date.getTime())) return "";

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    let formattedDate = `${day}-${month}-${year}`;

    if (showTime) {
      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? String(hours).padStart(2, "0") : "12";

      formattedDate += ` ${hours}:${minutes}${ampm}`;
    }

    return formattedDate;
  }

  const getUserFromDecodedToken = (decodedUser) => {
    if (!decodedUser?.sub) return null;

    try {
      const fixedString = decodedUser.sub.replace(/'/g, '"');
      return JSON.parse(fixedString);
    } catch (error) {
      console.error("Invalid token sub format");
      return null;
    }
  };

  const {
    data: pdfData,
    isLoading,
    refetch,
  } = useQuery(
    ["fetch-report-pdf", investigationIds, appointment],
    () =>
      fetchReportPDf({
        investigation_id: investigationIds,
        appointment_id: appointment,
        token,
      }),
    {
      staleTime: STALE_TIME,
      select: (res) => {
        return res?.data[0];
      },
      onError: (res) => {
        console.error(
          "Error fetching Investigation/Manager Delivery Days List:",
          res,
        );
      },
      enabled: !!investigationIds.length && !!appointment,
    },
  );

  const ageDetails = convertSecondsToAge(pdfData?.patient_obj?.age || 0);

  // const decodedUser = token ? jwtDecode(token) : null;

  // const userFromToken = getUserFromDecodedToken(decodedUser);

  // const zoneId = userFromToken?.zone_id;
  // const employeeCodeId = userFromToken?.employee_code_id;

  const results = useQueries({
    queries: [
      {
        queryKey: ["fetch-header-list"],
        queryFn: () =>
          fetchHeaderFooterImageList({
            zone_id: zoneId || zoneLocalStorageId(),
            is_active: true,
            created_by: jwtAuthreducer?.user?.employee_code_id,
            header: true,
            token,
          }),
        staleTime: STALE_TIME,
      },
      {
        queryKey: ["fetch-footer-list"],
        queryFn: () =>
          fetchHeaderFooterImageList({
            zone_id: zoneId || zoneLocalStorageId(),
            is_active: true,
            created_by: jwtAuthreducer?.user?.employee_code_id,
            footer: true,
            token,
          }),
        staleTime: STALE_TIME,
      },
    ],
  });

  // console.log(
  //   "***************************results***************************",
  //   results
  // );

  const data = {
    data: {
      data: [
        ...(results[0]?.data?.data || []),
        ...(results[1]?.data?.data || []),
      ],
    },
  };

  // console.log(
  //   "***************************data***************************",
  //   data?.data?.data
  // );

  const headerObject = data?.data?.data.find((item) => item.header === true);
  const footerObject = data?.data?.data.find((item) => item.footer === true);

  useEffect(() => {
    let barcodeData = {
      barcode_ids: [100000000005],
    };
    dispatch(getBarcodeImage({ token, barcodeData }));
  }, []);

  // const doctorId = pdfData?.appointment_investigation_obj[0]?.
  //   observations_obj[0]?.doctor_id
  const doctorId =
    pdfData?.appointment_investigation_obj
      ?.flatMap((investigation) => investigation.observations_obj || [])
      ?.find((observation) => observation?.doctor_id)?.doctor_id || null;
  // console.log("doctorid", doctorId)
  // const { data: doctorSigData, isError, error } = useQuery(
  //   ["fetch-signature", doctorId],
  //   () => fetchSignature({ doctor_id: doctorId }),
  //   {
  //     staleTime: STALE_TIME,
  //     enabled: !!doctorId && rowData?.doctor_type !== "EXTERNAL",
  //   }
  // );

  const {
    data: doctorSigData,
    isError,
    error,
  } = useQuery(
    ["fetch-signature", doctorId],
    () =>
      fetchSignature({ doctor_id: doctorId, zone_id: rowData?.zone_id, token }),
    {
      staleTime: STALE_TIME,
      enabled: !!doctorId && rowData?.doctor_type !== "EXTERNAL",
    },
  );

  const shouldHideBarcode = pdfData?.appointment_investigation_obj?.some(
    (item) => item?.hide_barcode_in_pdf === true,
  );

  const groupedData = pdfData?.appointment_investigation_obj?.reduce(
    (acc, item) => {
      const department = item?.lab_department_name || "Unknown Department";

      if (!acc[department]) {
        acc[department] = [];
      }

      acc[department].push(item);
      return acc;
    },
    {},
  );

  function formatHtmlString(input) {
    return input.replace(/<p>/g, "").replace(/<\/p>/g, "</br>");
  }

  // console.log("pdfData", pdfData?.QR_CODE_IMAGE_DATA);

  // console.log("pdf", pdfData?.franchise_obj?.show_date);

  return (
    <div>
      <style
        dangerouslySetInnerHTML={{
          __html:
            '\n      html {\n        font-family: Helvetica, Segoe UI, sans-serif;\n        /* 1 */\n        line-height: 1.5;\n        /* 2 */\n        -ms-text-size-adjust: 100%;\n        /* 3 */\n        -webkit-text-size-adjust: 100%;\n        /* 3 */\n        -webkit-font-smoothing: antialiased;\n      }\n\n      body {\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  width: 100%;\n        font-family: "Helvetica";\n        margin: 0 auto;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 1.5;\n        color: #000000;\n        background: #ffffff;\n        user-select: none;\n        -webkit-overflow-scrolling: touch;\n      }\n\n      html,\n      body {\n        height: 100%;\n      }\n\n      ::-webkit-scrollbar {\n        display: none;\n      }\n\n      img {\n        max-width: 100%;\n        border-style: none;\n      }\n\n      dl,\n      ol,\n      ul {\n        margin-bottom: 24px;\n      }\n\n      /**\n* 1. Remove the gray background on active links in IE 10.\n* 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n*/\n\n      a {\n        background-color: transparent;\n        /* 1 */\n        -webkit-text-decoration-skip: objects;\n        /* 2 */\n        text-decoration: none;\n      }\n\n      /**\n* Remove the outline on focused links when they are also active or hovered\n* in all browsers (opinionated).\n*/\n\n      a:active,\n      a:hover {\n        outline-width: 0;\n      }\n\n      /**\n* Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n*/\n\n      b,\n      strong {\n        font-weight: inherit;\n      }\n\n      /**\n* Add the correct font weight in Chrome, Edge, and Safari.\n*/\n\n      b,\n      strong {\n        font-weight: bolder;\n      }\n\n      sub,\n      sup {\n        font-size: 75%;\n        line-height: 0;\n        position: relative;\n        vertical-align: baseline;\n      }\n\n      sub {\n        bottom: -0.25em;\n      }\n\n      sup {\n        top: -0.5em;\n      }\n\n      img {\n        max-width: 100%;\n        border-style: none;\n      }\n\n      .h1,\n      h1 {\n        font-size: 2.5rem;\n        font-weight: bold;\n        margin-bottom: 24px;\n      }\n\n      .h2,\n      h2 {\n        font-size: 2rem;\n        font-weight: bold;\n        margin-bottom: 24px;\n      }\n\n      .h3,\n      h3 {\n        font-size: 1.75rem;\n        font-weight: bold;\n        margin-bottom: 24px;\n      }\n\n      /**\n* Hide the overflow in IE.\n*/\n\n      svg:not(:root) {\n        overflow: hidden;\n      }\n\n      /* Forms\n========================================================================== */\n\n      /**\n* 1. Change font properties to `inherit` in all browsers (opinionated).\n* 2. Remove the margin in Firefox and Safari.\n*/\n\n      button,\n      input,\n      optgroup,\n      select,\n      textarea {\n        font: inherit;\n        /* 1 */\n        margin: 0;\n        /* 2 */\n      }\n\n      button,\n      input {\n        /* 1 */\n        overflow: visible;\n      }\n\n      /**\n* Remove the inheritance of text transform in Edge, Firefox, and IE.\n* 1. Remove the inheritance of text transform in Firefox.\n*/\n\n      button,\n      select {\n        /* 1 */\n        text-transform: none;\n      }\n\n      /**\n* 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n*    controls in Android 4.\n* 2. Correct the inability to style clickable types in iOS and Safari.\n*/\n\n      button,\nhtml [type=\'button\'],\n\n  /* 1 */\n\n[type=\'reset\'],\n[type=\'submit\'] {\n        -webkit-appearance: button;\n        /* 2 */\n      }\n\n      /**\n* Correct the cursor style of increment and decrement buttons in Chrome.\n*/\n\n      [type="number"]::-webkit-inner-spin-button,\n      [type="number"]::-webkit-outer-spin-button {\n        height: auto;\n      }\n\n      /**\n* 1. Correct the odd appearance in Chrome and Safari.\n* 2. Correct the outline style in Safari.\n*/\n\n      [type="search"] {\n        -webkit-appearance: textfield;\n        /* 1 */\n        outline-offset: -2px;\n        /* 2 */\n      }\n\n      /**\n* Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n*/\n\n      [type="search"]::-webkit-search-cancel-button,\n      [type="search"]::-webkit-search-decoration {\n        -webkit-appearance: none;\n      }\n\n      /**\n* 1. Correct the inability to style clickable types in iOS and Safari.\n* 2. Change font properties to `inherit` in Safari.\n*/\n\n      ::-webkit-file-upload-button {\n        -webkit-appearance: button;\n        /* 1 */\n        font: inherit;\n        /* 2 */\n      }\n\n      * {\n        -webkit-box-sizing: border-box;\n        -moz-box-sizing: border-box;\n        box-sizing: border-box;\n        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n      }\n\n      *:focus {\n        outline: none;\n      }\n      .container {\n        display: flex;\n        flex-direction: column;\n        position: relative;\n      }\n      .trademarkInfo {\n        width: 100%;\n        height: 250px;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        z-index: -1;\n      }\n      .trademarkInfo img {\n        width: 100%;\n        height: 100%;\n      }\n .header-container {\n  position: relative;\n padding-left: 25px;\n display: flex;\n  flex-direction: column;\n  align-items:center;\n  width: 100%;\n}\n   .main-header-container {\n  position: relative;\n }\n  header {\n        display: flex;\n        position:relative }\n      .headerLeft {\n        width: 300px;\n        height: 65px;\n        margin-top: 2px;\n        background: #57b0d8 url(../assets/pdfimg/blue-corner-bg.png) no-repeat top right;\n        background-size: 53px 84px;\n      }\n      .headerRight {\n        width: 100%;\n        height: 65px;\n        margin-top: 2px;\n        background: #57b0d8 url(../assets/pdfimg/blue-line-bg.png) no-repeat top left;\n        background-size: 121px 84px;\n      }\n      .logo {padding: 0 32px 0 15px;\n      } \n .coverImage {\n width: 100%;\n height: 50%; \n  margin-top: 13px;\n overflow: hidden;\n }\n \n .coverImage img { \n width: 100%; \n height: 100px; \n object-fit: cover; \n }  \n .footerImageContainer { \n width: 100%;  \n height: 150px; \n  margin-top: 5px;\n  margin-bottom: 10px;\n   \n} \n.footerImageContainer img {\n width: 100%;\n height: 100%;\n object-fit: cover;\n}\n  \n \n     .logo img {}\n      .barcodeInfo {\n        display: flex;\n        justify-content: flex-end;\n        width: 100%;\n        }\n      .barcodeImage {\n        display: flex;\n        height: 40px;\n}\n      .barcodeImage img {\n        height: 100%;\n      }\n      .mainSection {\n        display: flex;\n        flex-direction: column;\n        flex: 1;\n        width: 100%;\n        padding: 0 40px;\n        position: relative;\n      }\n      .main-header-container::before {\n        content: "";\n        font-size: 10px;\n        color: #757575;\n        line-height: 1.3;\n        position: absolute;\n        top: 198px;\n        left: -45px;\n        transform: rotate(-90deg);\n      }\n     .header-container .can-details-section {\n        width: 92%;\n       gap: 15px;\n        display: flex;\n        padding: 5px 5px 5px;\n     border:   2px solid #000000 !important\n      }\n      .can-column-one {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n      }\n      .can-column-two {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n      }\n      .can-detail-row {\n        width: 100%;\n        display: flex;\n  align-items: center;\n     }\n      .can-detail-label {\n    display: flex;\n        font-size: 13px;\n        color: #000000;\n        font-weight: 400;\n        line-height: 1.4;\n      }\n      .can-detail-text {\n        display: flex;\n        font-size: 13px;\n    width: 50%;\n    color: #000000;\n        font-weight: 400;\n        line-height: 1.4;\n      }\n      .dep-title {\n        font-size: 13px;\n        color: #000000;\n        font-weight: 600;\n        line-height: 1.4;\n        text-align: center;\n        text-decoration: underline;\n        text-transform: uppercase;\n        margin-top: 2px;\n      }\n      .rep-head-info {\n        display: flex;\n        font-size: 12px;\n        color: #000000;\n        font-weight: 600;\n        line-height: 1.4;\n        padding: 3px 0 0;\n        margin-bottom: 10px;\n        border-bottom: 2px solid #afafaf;\n      }\n      .rep-column-1 {\n     width: 45%;\n        display: flex;\n        flex-direction: column;\n        padding: 0 5px 0 0;\n  font-size:13px\n    }\n      .rep-column-2 {\n        display: flex;\n        flex-direction: column;\n        padding: 0 5px 0 0;\n   font-size:13px\n   }\n      .rep-column-3 {\n        font-size: 13px;\n        width: 15%;\n        display: flex;\n        flex-direction: column;\n        padding: 0 5px 0 0;\n      }\n      .rep-column-4 {\n        font-size: 12px;\n        width: 25%;\n        display: flex;\n        flex-direction: column;\n        padding: 0 0 0 2px;\n      }\n      .rep-details-row {\n        width: 100%;\n        display: flex;\n        font-size: 15px;\n        color: #000000;\n        font-weight: 400;\n        padding: 0 0 2px;\n      }\n      .name-title {\n        font-size: 10px;\n        color: #000000;\n        font-weight: 600;\n        text-decoration: underline;\n      }\n      .test-name {\n        font-size: 12px;\n        color: #000000;\n        font-weight: 400;\n        line-height: 1;\n      }\n      .test-name-details {\n        font-size: 10px;\n        color: #000000;\n        font-weight: 400;\n        line-height: 1.3;\n      }\n      .rep-sample-type {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        padding: 2px 0 6px;\n      }\n      .rep-test-type {\n        font-family: "Times New Roman", Times, serif;\n        font-size: 10px;\n        color: #000000;\n        font-weight: 600;\n        font-style: italic;\n      }\n      .rep-test-details {\n        font-size: 11px;\n        color: #000000;\n        font-weight: 600;\n        line-height: 1;\n        padding-top: 4px;\n      }\n      .rep-end-report {\n        width: 100%;\n        border-top: 2px solid #000000;\n      }\n      .rep-end-text {\n        font-family: "Times New Roman", Times, serif;\n        font-size: 12px;\n        color: #000000;\n        font-weight: 400;\n        line-height: 1.3;\n        padding: 5px 0;\n        text-align: center;\n      }\n      footer {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n  }\n      .footerTopRow {\n        font-family: "Times New Roman", Times, serif;\n        font-size: 12px;\n        color: #000000;\n        font-weight: 400;\n        line-height: 1;\n        padding: 0 0 0 18px;\n      }\n      .footer-doc-details {\n  width: 95%;\n margin: auto;\n      display: flex;\n    justify-content: space-between;\n    align-items: center;\n         gap: 10px;\n   padding: 2px 1px 6px 1px;\n    }\n      .scan-info img {\n       height: 86px;\n      }\n      .doc-text {\n        font-size: 10px;\n        color: #000000;\n        font-weight: 600;\n        line-height: 1.3;\n      }\n      .doc-column1 {\n        display: flex;\n        flex-direction: column;\n      }\n      .doc-column2 {\n        display: flex;\n        flex-direction: column;\n      }\n      .doc-column3 {\n        display: flex;\n        flex-direction: column;\n      }\n      .doc-column4 {\n        display: flex;\n        flex-direction: column;\n      }\n      .footerAddressInfo {\n     display: flex;\n     align-items:center;\n   padding: 0 0 6px 15px;\n      }\n      .approvedInfo {\n   padding-left:18px;  \n     display: flex;\n        flex-direction: column;\n      }\n      .approvedRow {\n        width: 100%;\n        display: flex;\n      }\n      .approvedLabel {\n        font-family: "Times New Roman", Times, serif;\n        font-size: 10px;\n        color: #010101;\n        font-weight: 600;\n        line-height: 1.3;\n      }\n      .approvedName {\n        font-family: "Times New Roman", Times, serif;\n        font-size: 10px;\n        color: #000000;\n        font-weight: 600;\n        line-height: 1.3;\n      }\n      .printDateRow {\n        width: 100%;\n        display: flex;\n      }\n      .printDateLabel {\n        font-family: "Times New Roman", Times, serif;\n        font-size: 10px;\n        color: #000000;\n        font-weight: 400;\n        line-height: 1.1;\n      }\n      .printDateText {\n        font-family: "Times New Roman", Times, serif;\n        font-size: 10px;\n        color: #000000;\n        font-weight: 400;\n        line-height: 1.1;\n      }\n      .labAddressInfo {\n        width: 50%;\n    justify-content:center;    \n    display: flex;\n        flex-direction: column;\n        align-items: center;\n      }\n      .labAddressText {\n        font-size: 9px;\n        color: #000000;\n        font-weight: 400;\n        line-height: 1.6;\n        text-align: center;\n      }\n      .labAddressText span {\n        color: #57b0d8;\n      }\n      .pageInfo {\n        width: 25%;\n        display: flex;\n        justify-content: flex-end;\n        position: relative;\n      }\n      .pageLogoInfo {\n        width: 50px;\n        height: 70px;\n        position: absolute;\n        bottom: 5px;\n        left: 0;\n      }\n      .pageText {\n        font-family: "Times New Roman", Times, serif;\n        font-size: 18px;\n        color: #000000;\n        font-weight: 400;\n        line-height: 1.1;\n        padding-right: 55px;\n      }\n      .footerBlueLine {\n        width: 100%;\n        height: 22px;\n        background: #58b0d8;\n        position: relative;\n      }\n      .footerBlueLine::before {\n        content: "";\n        position: absolute;\n        top: -76px;\n        right: 0;\n        border-top: 38px solid transparent;\n        border-left: 38px solid transparent;\n        border-bottom: 38px solid #58b0d8;\n        border-right: 38px solid #58b0d8;\n      }\n @media print {\n .container,.container-sm {\n max-width: 100%;\n} \n}  ',
        }}
      />
      <div className="container" id="content-id">
        {data?.data?.data?.length > 0 && headerObject ? (
          <>
            {display_header == "true" && (
              <>
                <div className="main-header-container">
                  <header
                    className="headerImage"
                    style={{
                      visibility:
                        display_banner == "true" ? "visible" : "hidden",
                    }}
                  >
                    <div className="coverImage">
                      <img
                        src={`data:image/png;base64,${headerObject?.file_data}`}
                        alt="Custom Image"
                      />
                    </div>
                  </header>
                  <div className="header-container mt-1">
                    <section className="can-details-section mt-2">
                      <div className="row w-100">
                        <div className="col-md-5">
                          <div className="can-detail-row">
                            <div className="can-detail-label">Name</div>
                            <span style={{ margin: "0 8px" }}>:</span>
                            <div className="can-detail-text">
                              <strong>
                                {pdfData?.patient_obj?.patient_name || ""}
                              </strong>
                            </div>
                          </div>
                          <div className="can-detail-row">
                            <div className="can-detail-label">Age/Gender:</div>
                            <div className="can-detail-text">
                              {ageDetails?.years} Y / {ageDetails?.months} M /{" "}
                              {ageDetails?.days} D{" "}
                              {pdfData?.patient_obj?.gender || ""}
                            </div>
                          </div>
                          {/* <div className="can-detail-row">
                            <div className="can-detail-label">Patient ID:</div>
                            <div className="can-detail-text">
                              {pdfData?.patient_obj?.id || ""}
                            </div>
                          </div> */}
                          <div className="can-detail-row">
                            <div className="can-detail-label">Barcode No:</div>
                            <div className="can-detail-text">
                              {pdfData?.appointment_investigation_obj[0]
                                ?.barcode_no || ""}
                            </div>
                          </div>
                          <div className="can-detail-row">
                            <div className="can-detail-label">Refer By:</div>
                            <div className="can-detail-text">
                              {pdfData?.refer_doctor_name || ""}
                            </div>
                          </div>
                          <div className="can-detail-row">
                            <div className="can-detail-label">
                              Laborator Name:
                            </div>
                            <div className="can-detail-text">
                              {pdfData?.lab_name || ""}
                            </div>
                          </div>
                          <div className="can-detail-row">
                            <div className="can-detail-label">
                              Processing Center:
                            </div>
                            <div className="can-detail-text">
                              {pdfData?.zone_name || ""}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-5">
                          <div className="can-detail-row">
                            <div className="can-detail-label">
                              Registration No:
                            </div>
                            <div className="can-detail-text">
                              {pdfData?.appointment_investigation_obj[0]
                                ?.appointment_id || ""}
                            </div>
                          </div>
                          <div className="can-detail-row">
                            <div className="can-detail-label">
                              Registration Date:
                            </div>
                            <div className="can-detail-text">
                              {pdfData?.appointment_detail_obj?.map(
                                (item, index) => (
                                  <div key={index}>
                                    {convertTimestampToDatetimeLocal(
                                      item?.generated,
                                      pdfData?.franchise_obj?.show_date,
                                    )}
                                  </div>
                                ),
                              )}
                            </div>
                          </div>
                          <div className="can-detail-row">
                            <div className="can-detail-label">
                              Receiving Date:
                            </div>
                            <div className="can-detail-text">
                              {pdfData?.appointment_investigation_obj?.[0]
                                ?.appointment_investigation_status_obj
                                ?.received_date
                                ? convertTimestampToDatetimeLocal(
                                    pdfData.appointment_investigation_obj[0]
                                      .appointment_investigation_status_obj
                                      .received_date,
                                    pdfData?.franchise_obj?.show_date,
                                  )
                                : ""}
                            </div>
                          </div>
                          <div className="can-detail-row">
                            <div className="can-detail-label">
                              Reporting Date:
                            </div>
                            <div className="can-detail-text">
                              {pdfData?.appointment_investigation_obj?.[0]
                                ?.appointment_investigation_status_obj
                                ?.reporting_date
                                ? convertTimestampToDatetimeLocal(
                                    pdfData.appointment_investigation_obj[0]
                                      .appointment_investigation_status_obj
                                      .reporting_date,
                                    pdfData?.franchise_obj?.show_date,
                                  )
                                : ""}
                            </div>
                          </div>
                          <div className="can-detail-row">
                            <div className="can-detail-label">Panel Code:</div>
                            <div className="can-detail-text">
                              {pdfData?.franchise_obj?.franchise_code || ""}
                            </div>
                          </div>
                          <div className="can-detail-row">
                            <div className="can-detail-label">Center:</div>
                            <div className="can-detail-text">
                              {pdfData?.zone_obj?.zone_name || ""}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-2">
                          {!shouldHideBarcode && (
                            <section className="barcodeInfo">
                              <div className="barcodeImages">
                                <div className="barcodeImage">
                                  <img
                                    src={`data:image/png;base64,${pdfData?.appointment_barcode_img?.ppointment_barcode_image}`}
                                    width={200}
                                    height={40}
                                  />
                                </div>
                              </div>
                            </section>
                          )}
                          <div className="d-flex justify-content-end">
                            <img src={pdfData?.QR_CODE_IMAGE_DATA} />
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </>
            )}
          </>
        ) : (
          <>
            {display_header == "true" &&
              pdfData?.appointment_investigation_obj?.map(
                (appointmentInvestigation, headerIndex) => (
                  <div
                    key={headerIndex}
                    className="main-header-container"
                    data-header-index={headerIndex}
                    data-investigation-id={
                      appointmentInvestigation.investigation_id
                    }
                  >
                    <header
                      className="headerImage"
                      style={{
                        display: display_banner == "true" ? "block" : "block",
                        height: display_banner == "true" ? "120px" : "120px",
                        overflow: "hidden",
                      }}
                    >
                      {display_banner == "true" && (
                        <img
                          src="../assets/pdfimg/new_header_logo1.jpeg"
                          alt="Medicity"
                        />
                      )}
                    </header>
                    <div className="header-container">
                      <div
                        style={{
                          position: "absolute",
                          top: "0%",
                          left: "-20px",
                          transform: "rotate(-90deg) translateX(-50%)",
                          transformOrigin: "center center",
                          whiteSpace: "nowrap",
                          fontSize: "10px",
                          color: "#757575",
                          lineHeight: "1.3",
                          zIndex: 10,
                        }}
                      >
                        Medicity Speciality Laboratory
                      </div>
                      <section className="can-details-section mt-2">
                        <div className="row w-100">
                          <div className="col-md-6">
                            <div className="d-flex">
                              <div style={{ minWidth: "140px" }}>Name</div>
                              <span className="mx-2">:</span>
                              <div className="flex-grow-1">
                                <strong>
                                  {pdfData?.patient_obj?.patient_name || ""}
                                </strong>
                              </div>
                            </div>

                            <div className="d-flex">
                              <div style={{ minWidth: "140px" }}>
                                Age/Gender
                              </div>
                              <span className="mx-2">:</span>
                              <div className="flex-grow-1">
                                {ageDetails?.years} Y / {ageDetails?.months} M /{" "}
                                {ageDetails?.days} D{" "}
                                {pdfData?.patient_obj?.gender || ""}
                              </div>
                            </div>

                            <div className="d-flex">
                              <div style={{ minWidth: "140px" }}>
                                Barcode No
                              </div>
                              <span className="mx-2">:</span>
                              <div className="flex-grow-1">
                                {appointmentInvestigation?.barcode_no || ""}
                              </div>
                            </div>

                            <div className="d-flex">
                              <div style={{ minWidth: "140px" }}>Refer By</div>
                              <span className="mx-2">:</span>
                              <div className="flex-grow-1">
                                {pdfData?.refer_doctor_name || ""}
                              </div>
                            </div>

                            <div className="d-flex">
                              <div style={{ minWidth: "140px" }}>
                                Laborator Name
                              </div>
                              <span className="mx-2">:</span>
                              <div className="flex-grow-1">
                                {pdfData?.lab_name || ""}
                              </div>
                            </div>

                            <div className="d-flex">
                              <div style={{ minWidth: "140px" }}>
                                Processing Center
                              </div>
                              <span className="mx-2">:</span>
                              <div className="flex-grow-1">
                                {pdfData?.zone_name || ""}
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="row">
                              <div className="col-9">
                                <div className="d-flex">
                                  <div
                                    style={{
                                      minWidth: "120px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Registration No
                                  </div>
                                  <span className="mx-2">:</span>
                                  <div className="flex-grow-1">
                                    {appointmentInvestigation?.appointment_id ||
                                      ""}
                                  </div>
                                </div>

                                <div className="d-flex">
                                  <div
                                    style={{
                                      minWidth: "120px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Registration Date
                                  </div>
                                  <span className="mx-2">:</span>
                                  <div className="flex-grow-1">
                                    {pdfData?.appointment_detail_obj?.map(
                                      (item, index) => (
                                        <div key={index}>
                                          {convertTimestampToDatetimeLocal(
                                            item?.generated,
                                            pdfData?.franchise_obj?.show_date,
                                          )}
                                        </div>
                                      ),
                                    )}
                                  </div>
                                </div>

                                <div className="d-flex">
                                  <div
                                    style={{
                                      minWidth: "120px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Receiving Date
                                  </div>
                                  <span className="mx-2">:</span>
                                  <div className="flex-grow-1">
                                    {appointmentInvestigation
                                      ?.appointment_investigation_status_obj
                                      ?.received_date
                                      ? convertTimestampToDatetimeLocal(
                                          appointmentInvestigation
                                            .appointment_investigation_status_obj
                                            .received_date,
                                          pdfData?.franchise_obj?.show_date,
                                        )
                                      : ""}
                                  </div>
                                </div>

                                <div className="d-flex">
                                  <div
                                    style={{
                                      minWidth: "120px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Reporting Date
                                  </div>
                                  <span className="mx-2">:</span>
                                  <div className="flex-grow-1">
                                    {appointmentInvestigation
                                      ?.appointment_investigation_status_obj
                                      ?.reporting_date
                                      ? convertTimestampToDatetimeLocal(
                                          appointmentInvestigation
                                            .appointment_investigation_status_obj
                                            .reporting_date,
                                          pdfData?.franchise_obj?.show_date,
                                        )
                                      : ""}
                                  </div>
                                </div>

                                <div className="d-flex">
                                  <div
                                    style={{
                                      minWidth: "120px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Center
                                  </div>
                                  <span className="mx-2">:</span>
                                  <div className="flex-grow-1">
                                    {pdfData?.zone_obj?.zone_name || ""}
                                  </div>
                                </div>

                                <div className="d-flex">
                                  <div
                                    style={{
                                      minWidth: "120px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Panel Code
                                  </div>
                                  <span className="mx-2">:</span>
                                  <div className="flex-grow-1">
                                    {pdfData?.franchise_obj?.franchise_code ||
                                      ""}
                                  </div>
                                </div>
                              </div>

                              <div
                                className="col-3"
                                style={{
                                  paddingLeft: "0",
                                  paddingRight: "0px",
                                }}
                              >
                                {!appointmentInvestigation?.hide_barcode_in_pdf && (
                                  <section className="barcodeInfo">
                                    <div className="barcodeImages">
                                      <div className="barcodeImage">
                                        <img
                                          src={`data:image/png;base64,${pdfData?.appointment_barcode_img?.ppointment_barcode_image}`}
                                          alt="barcode"
                                          width={200}
                                          height={40}
                                        />
                                      </div>
                                    </div>
                                  </section>
                                )}
                                <div className="d-flex justify-content-center">
                                  <img
                                    src={pdfData?.QR_CODE_IMAGE_DATA}
                                    alt="QR"
                                    style={{
                                      height: "70px",
                                      width: "70px",
                                      maxHeight: "70px",
                                      minHeight: "70px",
                                      display: "block",
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                ),
              )}
          </>
        )}
        {display_address === "true" && (
          <>
            <main className="mainSection">
              <section>
                {groupedData &&
                  Object.entries(groupedData).map(
                    ([departmentName, investigations], departmentIndex) => {
                      const departmentPageBreakStyle =
                        departmentIndex > 0
                          ? { pageBreakBefore: "always" }
                          : undefined;

                      const allObservations = investigations.flatMap(
                        (item) =>
                          item?.observations_obj?.filter((data) => {
                            const hasValue =
                              data?.observation_value !== null &&
                              data?.observation_value !== "";
                            const hasTemplateId = !!data?.template_id;
                            return (
                              data?.header === true || hasValue || hasTemplateId
                            );
                          }) || [],
                      );

                      console.log("allobe", allObservations);

                      const hasTemplateId = allObservations.some(
                        (obs) => !!obs.template_id,
                      );

                      const shouldShowUnit = allObservations.some(
                        (obs) => obs.unit,
                      );
                      const shouldShowRefRange = allObservations.some(
                        (obs) => obs.display_reading,
                      );

                      const shouldShowThead =
                        (shouldShowUnit || shouldShowRefRange) &&
                        !hasTemplateId;

                      console.log(
                        "*************************investigations*************************",
                        investigations,
                      );

                      return (
                        <div
                          key={departmentIndex}
                          style={departmentPageBreakStyle}
                          className="department-container"
                        >
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                              fontFamily: "Arial MT, Arial, sans-serif",
                            }}
                          >
                            <thead>
                              <tr>
                                <td colSpan="4">
                                  <div
                                    className="dep-title"
                                    style={{ margin: "0px" }}
                                  >
                                    DEPARTMENT OF{" "}
                                    {investigations[0]?.lab_department_name}
                                  </div>

                                  {shouldShowThead && (
                                    <>
                                      <div className="dep-title">
                                        {
                                          investigations[0]?.package_obj
                                            ?.package_name
                                        }
                                      </div>

                                      <div className="rep-head-info">
                                        <div className="rep-column-1">
                                          Test Name
                                        </div>
                                        <div
                                          className="rep-column-2"
                                          style={{
                                            // fontSize: "13px",
                                            fontWeight: "bold",
                                            // ...(!data?.unit &&
                                            // !data?.display_reading
                                            //   ? { width: "15%" }
                                            //   : {}),
                                            width:
                                              !shouldShowUnit &&
                                              !shouldShowRefRange
                                                ? "65%"
                                                : "15%",
                                          }}
                                        >
                                          Result
                                        </div>
                                        {(shouldShowUnit ||
                                          shouldShowRefRange) && (
                                          <div className="rep-column-3">
                                            Unit
                                          </div>
                                        )}

                                        {(shouldShowUnit ||
                                          shouldShowRefRange) && (
                                          <div className="rep-column-4">
                                            Biological Ref.Interval
                                          </div>
                                        )}
                                      </div>
                                    </>
                                  )}
                                </td>
                              </tr>
                            </thead>

                            <tbody>
                              {investigations.map((item, index) => {
                                const isLastInvestigation =
                                  index === investigations.length - 1;
                                const isLastDepartment =
                                  departmentIndex ===
                                  Object.entries(groupedData).length - 1;
                                const isCompletelyLastItem =
                                  isLastInvestigation && isLastDepartment;
                                // const observationsWithValues =
                                //   item?.observations_obj?.filter(
                                //     (data) =>
                                //       data?.header === true ||
                                //       (data?.observation_value !== null &&
                                //         data?.observation_value !== "")
                                //   ) || [];

                                // const observationsWithValues =
                                //   item?.observations_obj?.filter((data) => {
                                //     const hasValue =
                                //       data?.observation_value !== null &&
                                //       data?.observation_value !== "";

                                //     const hasTemplateId = !!data?.template_id;

                                //     return (
                                //       data?.header === true ||
                                //       hasValue ||
                                //       hasTemplateId
                                //     );
                                //   }) || [];

                                const observationsWithValues =
                                  item?.observations_obj?.filter((data) => {
                                    const hasValue =
                                      data?.observation_value !== null &&
                                      data?.observation_value !== "";

                                    const hasTemplateId = !!data?.template_id;

                                    const hasTemplateDescription =
                                      !!data?.template_description;

                                    return (
                                      data?.header === true ||
                                      hasValue ||
                                      hasTemplateId ||
                                      hasTemplateDescription
                                    );
                                  }) || [];

                                let hasRenderedInvestigationName = false;

                                const pageBreakStyle = item?.print_separate
                                  ? {
                                      pageBreakBefore: "always",
                                      ...(isLastInvestigation
                                        ? {}
                                        : { pageBreakAfter: "always" }),
                                    }
                                  : undefined;

                                // console.log(
                                //   "observationsWithValues",
                                //   observationsWithValues
                                // );

                                return (
                                  <tr key={item?.investigation_id}>
                                    <td colSpan="4">
                                      <div style={pageBreakStyle}>
                                        <style
                                          dangerouslySetInnerHTML={{
                                            __html: `
                                  @media print {
                                    thead { display: table-header-group; }
                                    tfoot { display: table-footer-group; }
                                  }
                                `,
                                          }}
                                        />

                                        {!hasRenderedInvestigationName &&
                                          item?.show_name_in_patient_report && (
                                            <div
                                              className="rep-details-row"
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                marginBottom: "8px",
                                              }}
                                            >
                                              <div
                                                className="name-title"
                                                style={{
                                                  textAlign: "center",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                {item?.investigation_name || ""}
                                              </div>
                                            </div>
                                          )}
                                        {(hasRenderedInvestigationName = true)}

                                        {observationsWithValues.map(
                                          (data, observationIndex, arr) => {
                                            const isLastObservation =
                                              observationIndex ===
                                              arr.length - 1;

                                            let pageBreakBefore = "auto";
                                            let pageBreakAfter = "auto";

                                            if (data?.template_obj) {
                                              const observationsWithTemplateObj =
                                                arr.filter(
                                                  (item) => item?.template_obj,
                                                );
                                              const templateObjIndex =
                                                observationsWithTemplateObj.findIndex(
                                                  (item) =>
                                                    item.observation_id ===
                                                    data.observation_id,
                                                );

                                              const isFirstTemplateObj =
                                                templateObjIndex === 0;
                                              const isLastTemplateObj =
                                                templateObjIndex ===
                                                observationsWithTemplateObj.length -
                                                  1;
                                              const hasMultipleTemplateObj =
                                                observationsWithTemplateObj.length >
                                                1;

                                              if (hasMultipleTemplateObj) {
                                                if (isFirstTemplateObj) {
                                                  pageBreakAfter = "always";
                                                } else if (isLastTemplateObj) {
                                                  pageBreakBefore = "always";
                                                } else {
                                                  pageBreakBefore = "always";
                                                  pageBreakAfter = "always";
                                                }
                                              }
                                            }

                                            console.log(
                                              "data in observation with values",
                                              data,
                                            );

                                            const allMachineNames =
                                              observationsWithValues
                                                .map((obs) => obs?.machine_name)
                                                .filter(Boolean);

                                            const machineNameToShow =
                                              allMachineNames[0] || "";

                                            return (
                                              <div
                                                key={data?.observation_id}
                                                style={{
                                                  ...(!data?.template_obj && {
                                                    pageBreakInside: "avoid",
                                                    breakInside: "avoid",
                                                  }),
                                                  ...(data?.template_obj && {
                                                    pageBreakBefore:
                                                      pageBreakBefore,
                                                    pageBreakAfter:
                                                      pageBreakAfter,
                                                  }),
                                                }}
                                                className="observation-container"
                                              >
                                                {data?.header ? (
                                                  <div
                                                    style={{
                                                      fontSize: "12px",
                                                      fontWeight:
                                                        data?.bold && "bold",
                                                      textTransform:
                                                        "uppercase",
                                                      textDecoration:
                                                        "underline",
                                                      color: "black",
                                                      marginBottom: ".50rem",
                                                    }}
                                                  >
                                                    {data?.observation_name ||
                                                      ""}
                                                  </div>
                                                ) : data?.template_description ? (
                                                  <div>
                                                    <div
                                                      style={{
                                                        color: "black",
                                                        lineHeight: "1.2",
                                                      }}
                                                      className="template-container"
                                                      dangerouslySetInnerHTML={{
                                                        __html:
                                                          data?.template_description ||
                                                          "",
                                                      }}
                                                    ></div>

                                                    <style>
                                                      {`
                                                        .template-container p {
                                                          margin: 0; 
                                                          padding: 0;
                                                        }
                                                        .template-container div {
                                                          margin: 0;
                                                          padding: 0;
                                                        }
                                                        .template-container ul, .template-container ol {
                                                          list-style-type: disc;
                                                          padding-left: 20px;
                                                          margin: 5px 0; 
                                                        }
                                                    `}
                                                    </style>

                                                    {data?.comments && (
                                                      <div
                                                        style={{
                                                          color: "black",
                                                          textAlign: "justify",
                                                          fontFamily:
                                                            "Arial MT, Arial, sans-serif",
                                                          marginTop: "2px",
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                          __html: data.comments,
                                                        }}
                                                      />
                                                    )}

                                                    <style>
                                                      {`
                                                            div ul {
                                                              list-style-type: disc;
                                                              padding-left: 20px;
                                                            }
                                                            div ol {
                                                              list-style-type: decimal;
                                                              padding-left: 20px;
                                                            }
                                                          `}
                                                    </style>
                                                    {data?.interpretation && (
                                                      <div
                                                        style={{
                                                          color: "black",
                                                          fontFamily:
                                                            "Arial, sans-serif",
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            data.interpretation,
                                                        }}
                                                      />
                                                    )}
                                                    <style>
                                                      {`
                                                        div ul {
                                                          list-style-type: disc;
                                                          padding-left: 20px;
                                                        }
                                                        div ol {
                                                          list-style-type: decimal;
                                                          padding-left: 20px;
                                                        }
                                                      `}
                                                    </style>
                                                  </div>
                                                ) : (
                                                  <>
                                                    <div className="rep-details-row mb-1">
                                                      <div className="rep-column-1">
                                                        {/* <div
                                                          className="test-name"
                                                          style={{
                                                            fontSize: "12px",
                                                            fontWeight:
                                                              data?.bold &&
                                                              "bold",
                                                          }}
                                                        >
                                                          {data?.observation_name ||
                                                            ""}
                                                        </div> */}
                                                        <div
                                                          className="test-name"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            gap: "4px",
                                                            fontSize: "12px",
                                                            fontWeight:
                                                              data?.bold &&
                                                              "bold",
                                                          }}
                                                        >
                                                          {data?.is_obs_nabl && (
                                                            <img
                                                              src={NABL_LOGO}
                                                              alt="NABL Logo"
                                                              style={{
                                                                width: "15px",
                                                                height: "15px",
                                                                objectFit:
                                                                  "contain",
                                                              }}
                                                            />
                                                          )}

                                                          {data?.observation_name ||
                                                            ""}
                                                        </div>
                                                        <div
                                                          className="test-name-details"
                                                          style={{
                                                            fontSize: "8px",
                                                          }}
                                                        >
                                                          {data?.method_name ||
                                                            ""}
                                                        </div>

                                                        {isLastObservation &&
                                                          machineNameToShow && (
                                                            <div
                                                              className="rep-test-details"
                                                              style={{
                                                                fontSize:
                                                                  "10px",
                                                              }}
                                                            >
                                                              Test has been
                                                              performed on{" "}
                                                              {
                                                                machineNameToShow
                                                              }
                                                            </div>
                                                          )}

                                                        {/* Sample type only on the last observation */}
                                                        {isLastObservation && (
                                                          <>
                                                            {Array.isArray(
                                                              item?.sample_type_obj,
                                                            ) &&
                                                              item
                                                                .sample_type_obj
                                                                .length > 0 && (
                                                                <div className="rep-sample-type">
                                                                  <div
                                                                    className="rep-test-type"
                                                                    style={{
                                                                      fontSize:
                                                                        "8px",
                                                                      fontWeight:
                                                                        "200",
                                                                    }}
                                                                  >
                                                                    Sample Type:{" "}
                                                                    <span>
                                                                      {item.sample_type_obj
                                                                        .map(
                                                                          (
                                                                            sample,
                                                                          ) =>
                                                                            sample.sample_type,
                                                                        )
                                                                        .join(
                                                                          ", ",
                                                                        )}
                                                                    </span>
                                                                  </div>
                                                                </div>
                                                              )}
                                                          </>
                                                        )}
                                                      </div>
                                                      <div
                                                        className="rep-column-2"
                                                        style={{
                                                          // fontSize: "10px",
                                                          fontWeight:
                                                            !isNaN(
                                                              Number(
                                                                data?.observation_value,
                                                              ),
                                                            ) &&
                                                            !isNaN(
                                                              Number(
                                                                data?.min_reading,
                                                              ),
                                                            ) &&
                                                            !isNaN(
                                                              Number(
                                                                data?.max_reading,
                                                              ),
                                                            ) &&
                                                            !(
                                                              Number(
                                                                data?.min_reading,
                                                              ) === 0 &&
                                                              Number(
                                                                data?.max_reading,
                                                              ) === 0
                                                            ) &&
                                                            (Number(
                                                              data?.observation_value,
                                                            ) <
                                                              Number(
                                                                data?.min_reading,
                                                              ) ||
                                                              Number(
                                                                data?.observation_value,
                                                              ) >
                                                                Number(
                                                                  data?.max_reading,
                                                                ))
                                                              ? "bold"
                                                              : "400",
                                                          ...(item?.is_culture
                                                            ? { width: "50%" }
                                                            : {
                                                                width:
                                                                  shouldShowThead
                                                                    ? "15%"
                                                                    : "50%",
                                                              }),
                                                          // width: "15%",
                                                        }}
                                                      >
                                                        {data?.observation_value ||
                                                          ""}
                                                      </div>
                                                      {!item?.is_culture &&
                                                        shouldShowThead && (
                                                          <div className="rep-column-3">
                                                            {data?.unit || ""}
                                                          </div>
                                                        )}

                                                      {!item?.is_culture &&
                                                        shouldShowThead && (
                                                          <div className="rep-column-4">
                                                            {data?.display_reading
                                                              ?.split("\n")
                                                              .map(
                                                                (
                                                                  line,
                                                                  lineIndex,
                                                                ) => (
                                                                  <div
                                                                    key={
                                                                      lineIndex
                                                                    }
                                                                  >
                                                                    {line}
                                                                  </div>
                                                                ),
                                                              )}
                                                          </div>
                                                        )}
                                                    </div>

                                                    {/* Comments and interpretation only on the last observation */}
                                                    {isLastObservation && (
                                                      <>
                                                        {data?.comments && (
                                                          <div
                                                            style={{
                                                              color: "black",
                                                              textAlign:
                                                                "justify",
                                                              fontFamily:
                                                                "Arial MT, Arial, sans-serif",
                                                              marginTop: "2px",
                                                            }}
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                                data.comments,
                                                            }}
                                                          />
                                                        )}

                                                        <style>
                                                          {`
                                                            div ul {
                                                              list-style-type: disc;
                                                              padding-left: 20px;
                                                            }
                                                            div ol {
                                                              list-style-type: decimal;
                                                              padding-left: 20px;
                                                            }
                                                          `}
                                                        </style>

                                                        {data?.interpretation && (
                                                          <div
                                                            style={{
                                                              color: "black",
                                                              fontFamily:
                                                                "Arial, sans-serif",
                                                            }}
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                                data.interpretation,
                                                            }}
                                                          />
                                                        )}

                                                        <style>
                                                          {`
                                                              div ul {
                                                                list-style-type: disc;
                                                                padding-left: 20px;
                                                              }
                                                              div ol {
                                                                list-style-type: decimal;
                                                                padding-left: 20px;
                                                              }
                                                            `}
                                                        </style>
                                                      </>
                                                    )}
                                                  </>
                                                )}
                                              </div>
                                            );
                                          },
                                        )}

                                        {item?.is_culture &&
                                          item?.observations_organism_obj &&
                                          item.observations_organism_obj
                                            .length > 0 && (
                                            <div
                                              style={{
                                                // marginTop: "20px",
                                                marginBottom: "5px",
                                              }}
                                            >
                                              <table
                                                style={{
                                                  width: "80%",
                                                  borderCollapse: "collapse",
                                                  border: "1px solid #333",
                                                  color: "#000",
                                                }}
                                              >
                                                <thead>
                                                  <tr>
                                                    <th
                                                      style={{
                                                        border:
                                                          "1px solid #333",
                                                        padding: "3px 8px",
                                                        fontSize: "10px",
                                                      }}
                                                    >
                                                      Sr. No.
                                                    </th>
                                                    <th
                                                      style={{
                                                        border:
                                                          "1px solid #333",
                                                        padding: "3px 8px",
                                                        fontSize: "10px",
                                                      }}
                                                    >
                                                      Observation
                                                    </th>
                                                    <th
                                                      style={{
                                                        border:
                                                          "1px solid #333",
                                                        padding: "3px 8px",
                                                        fontSize: "10px",
                                                      }}
                                                    >
                                                      Zone of Inhibition
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {item.observations_organism_obj.map(
                                                    (organism, orgIndex) => (
                                                      <tr key={orgIndex}>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid #333",
                                                            padding: "3px 8px",
                                                            fontSize: "10px",
                                                            width: "10%",
                                                          }}
                                                        >
                                                          {orgIndex + 1}
                                                        </td>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid #333",
                                                            padding: "3px 8px",
                                                            fontSize: "10px",
                                                            width: "45%",
                                                          }}
                                                        >
                                                          {organism
                                                            ?.observation_obj
                                                            ?.observation || ""}
                                                        </td>
                                                        <td
                                                          style={{
                                                            border:
                                                              "1px solid #333",
                                                            padding: "3px 8px",
                                                            fontSize: "10px",
                                                            width: "30%",
                                                            fontWeight:
                                                              !isNaN(
                                                                Number(
                                                                  data?.observation_value,
                                                                ),
                                                              ) &&
                                                              !isNaN(
                                                                Number(
                                                                  data?.min_reading,
                                                                ),
                                                              ) &&
                                                              !isNaN(
                                                                Number(
                                                                  data?.max_reading,
                                                                ),
                                                              ) &&
                                                              !(
                                                                Number(
                                                                  data?.min_reading,
                                                                ) === 0 &&
                                                                Number(
                                                                  data?.max_reading,
                                                                ) === 0
                                                              ) &&
                                                              (Number(
                                                                data?.observation_value,
                                                              ) <
                                                                Number(
                                                                  data?.min_reading,
                                                                ) ||
                                                                Number(
                                                                  data?.observation_value,
                                                                ) >
                                                                  Number(
                                                                    data?.max_reading,
                                                                  ))
                                                                ? "bold"
                                                                : "400",
                                                          }}
                                                        >
                                                          {organism?.observation_value ||
                                                            ""}
                                                          {organism?.observation_value_mac_reading &&
                                                            `, ${organism?.observation_value_mac_reading}`}
                                                        </td>
                                                      </tr>
                                                    ),
                                                  )}
                                                </tbody>
                                              </table>

                                              {observationsWithValues.map(
                                                (obs, idx) => (
                                                  <React.Fragment
                                                    key={`culture-comments-${idx}`}
                                                  >
                                                    {obs?.comments && (
                                                      <div
                                                        style={{
                                                          color: "black",
                                                          textAlign: "justify",
                                                          fontFamily:
                                                            "Arial MT, Arial, sans-serif",
                                                          marginTop: "2px",
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                          __html: obs.comments,
                                                        }}
                                                      />
                                                    )}

                                                    {obs?.interpretation && (
                                                      <div
                                                        style={{
                                                          color: "black",
                                                          fontFamily:
                                                            "Arial, sans-serif",
                                                          marginTop: "2px",
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            obs.interpretation,
                                                        }}
                                                      />
                                                    )}
                                                  </React.Fragment>
                                                ),
                                              )}

                                              <style>
                                                {`
                                                    div ul {
                                                      list-style-type: disc;
                                                      padding-left: 20px;
                                                    }
                                                    div ol {
                                                      list-style-type: decimal;
                                                      padding-left: 20px;
                                                    }
                                                `}
                                              </style>
                                            </div>
                                          )}

                                        {item?.rejection_reason_obj
                                          ?.sample_rejection_reason && (
                                          <div>
                                            <p
                                              style={{
                                                color: "black",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              **Sample Reject:{" "}
                                              {item.rejection_reason_obj.sample_rejection_reason.trim()}
                                              **
                                            </p>

                                            {Array.isArray(
                                              item?.sample_type_obj,
                                            ) &&
                                              item.sample_type_obj.length >
                                                0 && (
                                                <div className="rep-sample-type">
                                                  <div
                                                    className="rep-test-type"
                                                    style={{
                                                      fontSize: "8px",
                                                      fontWeight: "200",
                                                    }}
                                                  >
                                                    Sample Type:{" "}
                                                    <span>
                                                      {item.sample_type_obj
                                                        .map(
                                                          (sample) =>
                                                            sample.sample_type,
                                                        )
                                                        .join(", ")}
                                                    </span>
                                                  </div>
                                                </div>
                                              )}
                                          </div>
                                        )}

                                        {isCompletelyLastItem && (
                                          <div className="rep-end-report">
                                            <div className="rep-end-text">
                                              *** End Of Report ***
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      );
                    },
                  )}

                {pdfData?.appointment_investigation_obj.map(
                  (app_inv, appIndex) =>
                    app_inv.appointment_investigation_file_data.map(
                      (file, fileIndex) => (
                        <React.Fragment key={`${appIndex}-${fileIndex}`}>
                          <div
                            style={{
                              // pageBreakBefore: "always",
                              height: "1px",
                              display: "block",
                              margin: "0",
                              padding: "0",
                            }}
                          ></div>

                          <div
                            className="no-header-footer test-container"
                            data-no-header-footer="true"
                          >
                            <div
                              className="tag-marker"
                              style={
                                {
                                  // border: "1px solid #ccc",
                                  // padding: "2px",
                                  // margin: "2px",
                                  // fontSize: "8px",
                                }
                              }
                            >
                              {/* TAG_GLUCOSPP */}
                            </div>

                            {/* <div style={{ width: '100%' }}>
                          <RenderPdfFromBase64 base64={file.file_data} />
                        </div> */}
                          </div>
                        </React.Fragment>
                      ),
                    ),
                )}

                {pdfData?.appointment_investigation_obj.map(
                  (app_inv, appIndex) =>
                    app_inv.appointment_investigation_file_data.map(
                      (file, index) => {
                        const ext = file.file_name
                          ?.split(".")
                          .pop()
                          ?.toLowerCase();

                        let mimeType = "";
                        if (ext === "pdf") {
                          mimeType = "application/pdf";
                        } else if (ext === "png") {
                          mimeType = "image/png";
                        } else if (ext === "jpg" || ext === "jpeg") {
                          mimeType = "image/jpeg";
                        }

                        return (
                          <div
                            key={`${appIndex}-${index}`}
                            style={{ marginTop: "20px" }}
                          >
                            {mimeType === "application/pdf" ? (
                              <iframe
                                src={`data:${mimeType};base64,${file.file_data}`}
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  // border: "1px solid #ccc",
                                }}
                                title={file.file_name}
                              />
                            ) : (
                              <img
                                src={`data:${mimeType};base64,${file.file_data}`}
                                alt={file.file_name}
                                style={{
                                  width: "100%",
                                  maxHeight: "auto",
                                  objectFit: "contain",
                                  // border: "1px solid #ccc",
                                }}
                              />
                            )}
                          </div>
                        );
                      },
                    ),
                )}
              </section>
            </main>
          </>
        )}
        {data?.data?.data?.length > 0 && footerObject ? (
          <>
            <div className="footer-container">
              {display_footer == "true" && (
                <>
                  <div
                    className="footer-doc-details"
                    // style={{ marginTop: "20px" }}
                  >
                    <div className="doctor-info" style={{ width: "100%" }}>
                      {doctorSigData?.data && (
                        <img
                          src={`data:image/jpeg;base64,${doctorSigData.data}`}
                          alt="Doctor Signature"
                        />
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-12"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div className="approvedInfo">
                        {pdfData?.franchise_obj?.payment_mode === "CREDIT" && (
                          <div
                            className="footerTopRow"
                            style={{ padding: "0" }}
                          >
                            Sample Source:OSS.
                          </div>
                        )}
                        {/* <div className="approvedRow">
                          <div className="approvedLabel">Approved Name:</div>
                          <div className="approvedName">
                            {pdfData?.appointment_investigation_obj?.[0]
                              ?.appointment_investigation_status_obj
                              ?.approved_by?.employee_master?.[0]
                              ?.employee_name || ""}
                          </div>
                        </div> */}
                        <div className="printDateRow">
                          <div className="printDateLabel">Print Date:</div>
                          <div className="printDateText">
                            {(() => {
                              const today = new Date();
                              const dd = String(today.getDate()).padStart(
                                2,
                                "0",
                              );
                              const mm = String(today.getMonth() + 1).padStart(
                                2,
                                "0",
                              );
                              const yyyy = today.getFullYear();
                              return `${dd}-${mm}-${yyyy}`;
                            })()}
                          </div>
                        </div>
                      </div>
                      <div className="footerAddressInfo">
                        <div className="labAddressInfo">
                          <div className="labAddressText">
                            {pdfData?.zone_obj?.address}
                          </div>
                          <div className="labAddressText">
                            <span style={{ marginLeft: "5px" }}>Mobile:</span>{" "}
                            {pdfData?.zone_obj?.mobile_number}
                            <span>Email:</span> {pdfData?.zone_obj?.email}
                            <span style={{ marginLeft: "5px" }}>
                              Website:
                            </span>{" "}
                            {pdfData?.zone_obj?.website}
                          </div>
                        </div>
                        <div className="pageInfo">
                          {pdfData?.appointment_investigation_obj?.map(
                            (item, index) =>
                              item?.is_nabl && (
                                <div className="pageLogoInfo" key={index}>
                                  <img
                                    src="../assets/pdfimg/footer-mc-logo.png"
                                    alt="Footer Logo"
                                  />
                                </div>
                              ),
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-9">
                      <div
                        style={{
                          visibility:
                            display_footer_banner == "true"
                              ? "visible"
                              : "hidden",
                        }}
                      >
                        {/* <div className="footerImageContainer">
                          <img
                            src={`data:image/png;base64,${footerObject?.file_data}`}
                            alt="Dynamic Footer"
                          />
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      visibility:
                        display_footer_banner == "true" ? "visible" : "hidden",
                    }}
                  >
                    <div className="footerImageContainer">
                      <img
                        src={`data:image/png;base64,${footerObject?.file_data}`}
                        alt="Dynamic Footer"
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </>
        ) : (
          <>
            <div className="footer-container">
              {display_footer == "true" && (
                <>
                  <div
                    className="footer-doc-details"
                    // style={{ marginTop: "20px" }}
                  >
                    <div className="doctor-info" style={{ width: "100%" }}>
                      {doctorSigData?.data && (
                        <img
                          src={`data:image/jpeg;base64,${doctorSigData.data}`}
                          alt="Doctor Signature"
                        />
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-12"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div className="approvedInfo">
                        {pdfData?.franchise_obj?.payment_mode === "CREDIT" && (
                          <div
                            className="footerTopRow"
                            style={{ padding: "0" }}
                          >
                            Sample Source:OSS.
                          </div>
                        )}
                        <div className="printDateRow">
                          <div className="printDateLabel">Print Date:</div>
                          <div className="printDateText">
                            {(() => {
                              const today = new Date();
                              const dd = String(today.getDate()).padStart(
                                2,
                                "0",
                              );
                              const mm = String(today.getMonth() + 1).padStart(
                                2,
                                "0",
                              );
                              const yyyy = today.getFullYear();
                              return `${dd}-${mm}-${yyyy}`;
                            })()}
                          </div>
                        </div>
                      </div>
                      {/* <div className="footerAddressInfo"> */}
                      <div className="labAddressInfo">
                        <div className="labAddressText">
                          {pdfData?.zone_obj?.address}
                        </div>
                        <div className="labAddressText">
                          <span style={{ marginLeft: "5px" }}>Mobile:</span>{" "}
                          {pdfData?.zone_obj?.mobile_number}
                          <span>Email:</span> {pdfData?.zone_obj?.email}
                          <span style={{ marginLeft: "5px" }}>
                            Website:
                          </span>{" "}
                          {pdfData?.zone_obj?.website}
                        </div>
                      </div>
                      <div className="pageInfo">
                        {pdfData?.appointment_investigation_obj?.map(
                          (item, index) =>
                            item?.is_nabl && (
                              <div className="pageLogoInfo" key={index}>
                                <img
                                  src="../assets/pdfimg/footer-mc-logo.png"
                                  alt="Footer Logo"
                                />
                              </div>
                            ),
                        )}
                      </div>
                      {/* </div> */}
                    </div>

                    <div className="col-9">
                      <div
                        style={{
                          visibility:
                            display_footer_banner == "true"
                              ? "visible"
                              : "hidden",
                        }}
                      ></div>
                    </div>
                  </div>
                  <div
                    style={{
                      visibility:
                        display_footer_banner == "true" ? "visible" : "hidden",
                    }}
                  >
                    <div className="footerBlueLine"></div>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default InvoicePage;
